import { styled } from '@linaria/react';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { SegmentedControl } from '@daedalus/atlas/SegmentedControl';
export const PageWrapper = /*#__PURE__*/styled('div')({
  name: "PageWrapper",
  class: "p1hhaaj4",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ContentWrapper;
export const Content = /*#__PURE__*/styled(_exp())({
  name: "Content",
  class: "c1hynohv",
  propsAsIs: true
});
const _exp2 = /*#__PURE__*/() => SegmentedControl;
export const HeaderSelector = /*#__PURE__*/styled(_exp2())({
  name: "HeaderSelector",
  class: "h8z7hy8",
  propsAsIs: true
});

require("./styled.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styled.tsx");